
  <template>
  <v-container fluid>
    <v-toolbar flat>
      <v-tabs v-model="tab" align-with-title>
        <v-tabs-slider color="white"></v-tabs-slider>
        <v-tab v-for="(cat, catindex) in categories" :key="catindex">
          <span v-if="categories.length > 1">{{ cat.name }}</span>
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="tab" style="background-color: #fbfbfb">
      <v-tab-item v-for="(cat, catindex) in categories" :key="catindex">
        <h4 class="ml-10 pt-4 text-primary">
          {{ department.index }}р анги:
          {{ department.numberOfStudents }}
          <span v-if="asuulgaDepartment != null"
            >{{ asuulgaDepartment.numberOfVotes }} |
            {{
              (
                asuulgaDepartment.numberOfVotes / department.numberOfStudents
              ).toFixed(2)
            }}%</span
          >
        </h4>
        <v-slide-group v-model="model" class="pa-4" center-active show-arrows>
          <v-slide-item
            v-for="(question, qindex) in cat.questions"
            :key="qindex"
            v-slot="{ toggle }"
          >
            <v-card
              class="mx-2"
              min-width="344"
              @click="toggle"
              v-if="
                _getAsuulgaQuestion(question) != null &&
                _getAsuulgaQuestion(question).numberOfVotes != null &&
                _getAsuulgaQuestion(question).numberOfVotes != undefined &&
                _getAsuulgaQuestion(question).numberOfVotes > 0
              "
            >
              <v-card-title style="word-break: break-word;">
                {{ qindex + 1 }}. {{ question.name }}
              </v-card-title>
              <v-card-subtitle>
                Нийт санал: {{ _getAsuulgaQuestion(question).numberOfVotes }} |
                эмэгтэй:
                {{ _getAsuulgaQuestion(question).numberOfVotesOfWomen }},
                эрэгтэй: {{ _getAsuulgaQuestion(question).numberOfVotesOfMen }}
              </v-card-subtitle>
              <v-card-actions>
                <div class="chart">
                  <bar-chart
                    style="max-height: 200px"
                    :chartData="_getChartData(question, null)"
                    :options="options"
                  ></bar-chart>
                </div>
              </v-card-actions>
            </v-card>
            <v-card v-else class="mx-2" min-width="300" max-width="300" @click="toggle">
                <v-card-title style="word-break: break-word;">
                  {{ qindex + 1 }}. {{ question.name }}
                </v-card-title>
                <v-card-actions
                  ><small class="text-danger text-center"
                    >Санал өгөөгүй байна</small
                  >
                </v-card-actions>
              
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>
  
  <script>
import { mapState } from "vuex";
import BarChart from "../../BarChart.js";
const fb = require("../../../firebaseConfig.js");
export default {
  data: () => ({
    model: null,
    tab: null,
    options: {
      maintainAspectRatio: false,
      responsive: true,
      scaleShowLabels: false,
      scales: {
        xAxes: [
          {
            ticks: {
              userCallback: function (label, index, labels) {
                if (typeof label === "string" && label.length > 10) {
                  return label.substring(0, 20) + " ...";
                }
                return label;
              },
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        ],
      },
    },
  }),
  components: {
    BarChart,
  },
  props: {
    asuulgaDepartment: {
      required: true,
    },
    department: {
      required: true,
    },
    categories: {
      required: true,
    },
    xcategories: {
      required: true,
    },
    femaleORmale: {
      required: true,
    },
  },
  created() {},
  methods: {
    _getResponceChartData(answer) {
      if (this.xcategories != null) {
        for (const xcat of this.xcategories) {
          if (xcat.questions != null) {
            for (const xquestion of xcat.questions) {
              if (xquestion.answers != null) {
                for (const xanswer of xquestion.answers) {
                  if (answer.id == xanswer.id) {
                    switch (this.femaleORmale) {
                      case "all":
                        return xanswer.numberOfVotes;
                        break;
                      case "female":
                        return xanswer.numberOfVotesOfWomen;
                        break;
                      case "male":
                        return xanswer.numberOfVotesOfMen;
                        break;
                    }
                  }
                }
              }
            }
          }
        }
      }
      return 0;
    },
    _getAsuulgaQuestion(question) {
      if (this.xcategories != null) {
        for (const xcat of this.xcategories) {
          if (xcat.questions != null) {
            for (const xquestion of xcat.questions) {
              if (xquestion.id == question.id) return xquestion;
            }
          }
        }
      }
      return null;
    },
    _getChartData(question, uclass) {
      if (question.answers != undefined && question.answers != null) {
        return {
          labels: question.answers.map((answer) => answer.name),
          datasets: [
            {
              label: [],
              backgroundColor: ["#D9F2B0"],
              data: question.answers.map((answer) =>
                this._getResponceChartData(answer)
              ),
            },
          ],
        };
      } else {
        return {
          labels: [],
          datasets: [],
        };
      }
    },
  },
};
</script>